import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useProductFeature} from "../hooks/useProductFeature.ts";
import {ProductFeature} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useProductFeature();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                description: '',
                category: '',
            } as ProductFeature}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
